import axios, { AxiosPromise } from 'axios';

import { ISeason } from '../../../@types/model/masterData/season/season';
import { ISeasonUpsert } from '../../../@types/model/masterData/season/seasonUpsert';

export default class SeasonHttpService {
    public static getSeasonData() : AxiosPromise<Array<ISeason>> {
        return axios.get(`${API_URL}/v1/Season/GetAllWeb`);
    }

    public static addOrUpdateSeason(upsert : ISeasonUpsert) : AxiosPromise<ISeason> {
        return axios.post(`${API_URL}/v1/Season/PostSeason`, upsert);
    }

    public static deleteSeason(seasonId : number) : AxiosPromise<ISeason> {
        return axios.delete(`${API_URL}/v1/Season/Delete`, {
            params : { seasonId },
        });
    }
}
